import { utcToJSDate } from "@/utils/date-time";
import { PaginationFilterRequest } from "./core.model";

export enum ClubEventParticipationStatusEnum {
  Joined = 1,
  CheckInPending = 2,
  CheckedIn = 3,
  Rejected = 4,
  Left = 5,
}

export const ClubEventParticipationStatusList = [
  { value: 1, label: "Joined" },
  { value: 2, label: "Check-in pending" },
  { value: 3, label: "Checked in" },
  { value: 4, label: "Rejected" },
  { value: 5, label: "Left" },
];

export interface ClubEventParticipationUser {
  id: number;
  firstName?: string;
  lastName?: string;
  username?: string;
  profilePicture?: string;
}

export interface ClubEventParticipation {
  /** The participation row's id — NOT the user's id. Use user.id to navigate to a user. */
  id: number;
  user: ClubEventParticipationUser;
  status: ClubEventParticipationStatusEnum;
  joinedAt?: Date;
  checkedInAt?: Date;
  /**
   * Whether the participant is an active member of the club(s) running the event — false marks
   * an outsider who joined an event open to non-members. Relative to the event, not the viewer.
   * Undefined on an Api that predates the field.
   */
  isClubMember?: boolean;
}

export function clubEventParticipationFromJson(json: any): ClubEventParticipation {
  return {
    ...json,
    joinedAt: utcToJSDate(json.joinedAt),
    checkedInAt: utcToJSDate(json.checkedInAt),
  } as ClubEventParticipation;
}

// NOTE: the Api's RunningClubEventUsersPaginationFilter (backing UsersPagedData) only
// accepts RunningClubEventId — there is no server-side `status` filter parameter.
// Status filtering for this list must happen client-side (see Task 4).
export class ClubEventParticipantsPaginationFilterRequest extends PaginationFilterRequest {
  runningClubEventId?: number;
}
